import Vue from 'vue'
import App from '@/App.vue'

import store from '@/store' 
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import api from '@/services/api'
import DefaultLayout from './layouts/DefaultLayout.vue'
import AuthLayout from './layouts/AuthLayout.vue'
import VueMeta from 'vue-meta'

import Toasted from 'vue-toasted'

Vue.config.productionTip = false

/* Добавляем токен при инициализации в headers если он есть */
const token = localStorage.getItem('user-token') || ''

if (token) {
  api.defaults.headers
    .common['Authorization'] = `Token ${token}`;
}
/* END */

Vue.component('default-layout', DefaultLayout)
Vue.component('auth-layout', AuthLayout)
Vue.use(VueMeta, { refreshOnceOnNavigation: true })

Vue.use(Toasted, {
  icon: 'check',
  duration: 5000,
  position: 'top-right'
})

import 'leaflet/dist/leaflet.css'
import '@/assets/scss/styles.scss'

const vue = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
})

vue.$mount('#app')
